import * as z from 'zod';
import { StoreRegion } from '~/graphql/graphql.gen';

export const discountQueryParamsSchema = z.object({
  region: z.enum([StoreRegion.Fr, StoreRegion.Us]).catch(StoreRegion.Fr),
});

export type DiscountQueryParams = z.infer<typeof discountQueryParamsSchema>;
